import { Pipe, PipeTransform } from '@angular/core';
import {isNullOrWhitespace, isNilOrEmpty} from 'helpers';
/*
 * Returns formatted string
 * for an object with a
 * firstName, middleName, lastName and nickname
 * properties. Missing properties will be ignored
 *
 *  *
 * Usage:
 *   user = {"firstName": "Foo", "lastName": "Bar", "middleName": "Baz", "nickname": "typical"}
 * Example:
 *   {{ user | fullName }}
 *   formats to: Foo "typical" Baz Bar
*/
@Pipe({name: 'fullName'})
export class FullNamePipe implements PipeTransform {
  transform(value: any): string {
    if (isNilOrEmpty(value)) {
      return '';
    }
    const nameParts: string[] = [];
    nameParts.push(value.firstName);
    if (value.nickname) {
      nameParts.push(`“${value.nickname}”`);
    }
    nameParts.push(value.middleName);
    nameParts.push(value.lastName);

    let result = nameParts.filter(t => !isNullOrWhitespace(t)).join(' ');

    // AB-810
    // stylizing the suffix with a comma for now
    // eg: Joseph "Joey" Ryan Williams, Jr.
    if (value.suffix) {
      result = result + ', ' + value.suffix;
    }

    return result;
  }
}
